import { render, staticRenderFns } from "./AdminColumnasComponent.vue?vue&type=template&id=bf78aa3c"
import script from "./AdminColumnasComponent.vue?vue&type=script&lang=ts"
export * from "./AdminColumnasComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports